/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios"
import { store } from "../../../store/app.store"
import { notification } from "../../component/notification/utility/notification"
import { setLoading } from "../auth-slice/auth-slice"
export let loading = false
async function getAccessToken(account: any) {
  store.dispatch(setLoading(true))
  await axios
    .post(`${import.meta.env.VITE_APP_API}/auth/login`, account)
    .then((response) => {
      localStorage.setItem("accessToken", response.data?.accessToken)
      localStorage.setItem("refreshToken", response.data?.refreshToken)

      return response.data?.access_token
    })
    .catch(function (error) {
      store.dispatch(setLoading(false))
      if (error.response) {
        notification("error", error.response.data.message)
      } else if (error.request) {
        notification("error", "Check your internet connection")
      } else {
        console.log("Error", error.message)
      }
    })
}

async function getOwnerInfo(userInfo: any) {
  try {
    if (userInfo?.role?.key != "owner") {
      return
    }
    return axios
      .get(
        `${import.meta.env.VITE_APP_API}/owners/get-owner/${
          userInfo?.id as string
        }?includes[0]=parentOwner`,
        {
          headers: {
            Authorization: `Bearer ${
              localStorage.accessToken ? await localStorage.accessToken : ""
            }`,
          },
        },
      )
      .then((response) => {
        localStorage.setItem("ownerInfo", JSON.stringify(response.data))
        return response.data
      })
      .catch(function (error) {
        if (error.response) {
          return
        } else if (error.request) {
          notification("error", "Check your internet connection")
        } else {
          console.log("Error", error.message)
        }
      })
  } catch (e) {
    return
  }
}
async function getTenantInfo(userInfo: any) {
  try {
    if (userInfo?.role?.key != "tenant") {
      return
    }
    return axios
      .get(
        `${import.meta.env.VITE_APP_API}/tenants/get-tenant/${
          userInfo?.id as string
        }?includes[0]=owner&includes[1]=owner.parentOwner`,
        {
          headers: {
            Authorization: `Bearer ${
              localStorage.accessToken ? await localStorage.accessToken : ""
            }`,
          },
        },
      )
      .then((response) => {
        localStorage.setItem("tenantInfo", JSON.stringify(response.data))
        return response.data
      })
      .catch(function (error) {
        if (error.response) {
          return
        } else if (error.request) {
          notification("error", "Check your internet connection")
        } else {
          console.log("Error", error.message)
        }
      })
  } catch (e) {
    return
  }
}

export async function userInfo(account: any) {
  store.dispatch(setLoading(true))
  await getAccessToken(account)

  return axios
    .get(`${import.meta.env.VITE_APP_API}/auth/get-user-info`, {
      headers: {
        Authorization: `Bearer ${
          localStorage.accessToken ? await localStorage.accessToken : ""
        }`,
      },
    })
    .then((response) => {
      store.dispatch(setLoading(false))
      localStorage.setItem("userInfo", JSON.stringify(response.data))
      localStorage.setItem("currentRole", JSON.stringify(response.data?.role))
      localStorage.setItem(
        "userRolePermissions",
        JSON.stringify(response?.data?.permissions),
      )
      getOwnerInfo(response.data)
      getTenantInfo(response.data)
      return response.data
    })
    .catch(function (error) {
      store.dispatch(setLoading(false))
      if (error.response) {
      } else if (error.request) {
        notification("error", "Check your internet connection")
      } else {
        console.log("Error", error.message)
      }
    })
}

export async function switchRole(roleId: string) {
  return axios
    .get(`${import.meta.env.VITE_APP_API}/auth/switch-role/${roleId}`, {
      headers: {
        Authorization: `Bearer ${
          localStorage.accessToken ? await localStorage.accessToken : ""
        }`,
      },
    })
    .then((response) => {
      localStorage.setItem("accessToken", response.data?.accessToken)
      localStorage.setItem("refreshToken", response.data?.refreshToken)
      localStorage.setItem(
        "currentRole",
        JSON.stringify(response?.data?.currentRole),
      )
      localStorage.setItem(
        "userRolePermissions",
        JSON.stringify(response?.data?.permissions),
      )
      return response.data
    })
    .catch(function (error) {
      if (error.response) {
      } else if (error.request) {
        notification("error", "Check your internet connection")
      } else {
        console.log("Error", error.message)
      }
    })
}
